import { ApiService } from "@/services"

export class DownloadsService extends ApiService {
	constructor() {
		super("/api/download")
	}

	async generateLink(uploadGuid: string) {
		return await this.returning(String).post("generate-link", uploadGuid)
	}
}
